module.exports = __webpack_public_path__ + "img/bg-mobile.ebbd7ee2.jpg";